import React, { useState, useEffect } from "react";
import { Drawer, Button, Tag, Typography, Skeleton, Space } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { fetchOrderByID } from "../../utils/fetchOrders";

const OrderDrawer = ({ orderId, onClose }) => {
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!orderId) { setOrder(null); return; }
    setIsLoading(true);
    fetchOrderByID(orderId)
      .then(setOrder)
      .catch(() => setOrder(null))
      .finally(() => setIsLoading(false));
  }, [orderId]);

  return (
    <Drawer
      open={!!orderId}
      onClose={onClose}
      title={
        order ? (
          <Space>
            <Tag className="font-mono">{order.daily_id}</Tag>
            <span>{order.name}</span>
          </Space>
        ) : "Pedido"
      }
      extra={
        <Button
          icon={<ExportOutlined />}
          size="small"
          onClick={() => window.open(`/orders/${orderId}`, "_blank")}
        >
          Abrir en nueva pestaña
        </Button>
      }
      width={480}
    >
      {isLoading || !order ? (
        <Skeleton active paragraph={{ rows: 8 }} />
      ) : (
        <div className="flex flex-col gap-5">
          <div>
            <Typography.Text type="secondary" className="text-xs uppercase tracking-wide">
              Dirección
            </Typography.Text>
            <Typography.Text className="block mt-1">
              {[order.address, order.city?.toUpperCase()].filter(Boolean).join(" — ")}
            </Typography.Text>
          </div>

          <div>
            <Typography.Text type="secondary" className="text-xs uppercase tracking-wide block mb-2">
              Productos ({order.products?.length ?? 0})
            </Typography.Text>
            {order.products?.map((p, i) => (
              <div
                key={i}
                className="flex justify-between items-center py-1 border-b border-gray-100 dark:border-gray-700 last:border-0"
              >
                <Typography.Text>
                  {p.product_name}{p.variant ? ` (${p.variant})` : ""}
                </Typography.Text>
                <Tag>{p.quantity}×</Tag>
              </div>
            ))}
          </div>

          <div>
            <Typography.Text type="secondary" className="text-xs uppercase tracking-wide block mb-2">
              Entregas ({order.delivery_info_array?.length ?? 0})
            </Typography.Text>
            {order.delivery_info_array?.map((d, i) => (
              <div
                key={i}
                className="mb-2 p-2 rounded bg-gray-50 dark:bg-gray-800"
              >
                <div className="flex justify-between items-center">
                  <Typography.Text>{d.delivery_date?.slice(0, 10) ?? "—"}</Typography.Text>
                  <Tag color={d.driver_id ? "blue" : "default"}>
                    {d.driver_name ?? "Sin chofer"}
                  </Tag>
                </div>
                {d.delivery_note && (
                  <Typography.Text type="secondary" className="text-xs block mt-1">
                    {d.delivery_note}
                  </Typography.Text>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default OrderDrawer;
